import defaultClient from '@/plugins/axios/defaultClient'
import defaultV2Client from '@/plugins/axios/defaultV2Client'

export default {
  /**
   *
   * @param {
   *  "licenseNumber": "1234-56-7890"
   *  "licenseImage": image
   * }store
   * @returns
   */
  postBusiness(business) {
    const formData = new FormData()
    for (const k in business) {
      formData.append(k, business[k])
    }

    return defaultClient.post('/businesses', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  putBusiness(uuid, business) {
    const formData = new FormData()
    for (const k in business) {
      formData.append(k, business[k])
    }

    return defaultClient.put(`/businesses/${uuid}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
